import type { ConfigType, Dayjs } from 'dayjs';
import dayjs from '@/utils/dayjs-instance';
import {
  type DistrictScheduleParsed,
  isDateAllowedBySchedule,
} from '../../../utils/districtScheduleUtils';

export function isoPlannedDateAfterCalendarPick(
  pickedCalendarValue: ConfigType,
  previousPlannedDateIso?: string | null
): string {
  const dateStr = dayjs(pickedCalendarValue).format('YYYY-MM-DD');
  const prevUtc = previousPlannedDateIso ? dayjs.utc(previousPlannedDateIso) : null;
  if (prevUtc?.isValid()) {
    return dayjs
      .utc(dateStr, 'YYYY-MM-DD')
      .hour(prevUtc.hour())
      .minute(prevUtc.minute())
      .second(prevUtc.second())
      .millisecond(prevUtc.millisecond())
      .toISOString();
  }
  return dayjs.utc(dateStr, 'YYYY-MM-DD').startOf('day').toISOString();
}

export interface OrderPlannedDateCalendarDisableOptions {
  districtSchedule?: DistrictScheduleParsed | null;
  upperBoundAheadDays?: number;
  now?: Dayjs;
}

export function isOrderPlannedDateCalendarDayDisabled(
  candidate: Dayjs | null | undefined,
  options: OrderPlannedDateCalendarDisableOptions = {}
): boolean {
  if (!candidate) return false;
  const { districtSchedule = null, upperBoundAheadDays = 15, now } = options;
  const today = now ?? dayjs();
  if (
    candidate.isBefore(today, 'day') ||
    candidate.isAfter(today.add(upperBoundAheadDays, 'day'), 'day')
  ) {
    return true;
  }
  if (districtSchedule && !isDateAllowedBySchedule(candidate, districtSchedule)) {
    return true;
  }
  return false;
}
